module.exports = __webpack_public_path__ + "media/images/products/products/ed3-e159f85f6087d87dc7459a3b7aad346b.jpg";